<template>
  <h1>setting fatturazione attiva</h1>
</template>
